export default __webpack_public_path__ + "static/media/010_home.a4aeeeba.mp4";